import { withInstall } from '@whale/utils';
import form from './src/form.vue';

export const WlErmForm = withInstall(form);
export default WlErmForm;
export * from './src/form';
